import * as Tooltip from '@radix-ui/react-tooltip';
import { ReactComponent as TooltipIcon } from './icons/tooltip.svg';
import { classNames } from '../utils';
import { ReactNode, useState } from 'react';

const tooltipStyles =
  'data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-violet11  select-none rounded-[4px] bg-white px-[15px] py-[10px] text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]';

export const LabelTooltip: React.FC<{
  children: string | ReactNode;
  tooltipClassName: string | undefined;
  iconClassName?: string | undefined;
  underlinedText?: string | undefined;
  underLinedTextClassName?: string | undefined;
}> = ({
  children,
  tooltipClassName,
  iconClassName,
  underlinedText,
  underLinedTextClassName,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip.Provider delayDuration={100}>
      <Tooltip.Root open={open} onOpenChange={setOpen}>
        <Tooltip.Trigger asChild>
          <span
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
          >
            {underlinedText ? (
              <div className={underLinedTextClassName}>{underlinedText}</div>
            ) : (
              <TooltipIcon
                className={classNames(
                  'ml-1 mt-[-1px] h-[10px] w-[10px] text-sidewalk-400',
                  iconClassName
                )}
              />
            )}
          </span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className={classNames(tooltipStyles, tooltipClassName)}
            sideOffset={5}
          >
            <Tooltip.Arrow className="fill-white" />
            <div className="text-body-small">{children}</div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
